<div class="wrap">
    <div class="dot"></div>

    <div class="circle">
    </div>
</div>
